<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>持續管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>持續管理</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left" class="form-inline">
                學年度：
                <select v-model="search.schYearTerm" class="form-control">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>　
                來源：
                <select v-model="search.sourceType" class="form-control">
                  <option :value="null">請選擇</option>
                  <option key="1" value="1">系統</option>
                  <option key="2" value="2">手動</option>
                </select>　
                參加者學號：
                <input type="text" name="name" class="form-control" v-model="search.stuId">　
                參加者姓名：
                <input type="text" name="name" class="form-control" v-model="search.stuName">
                <br style="margin-bottom: 10px;" />
                活動名稱：
                <input type="text" name="name" class="form-control" v-model="search.actionName">　
                活動開始日期：
                <datepicker ref="actionStartTime" :format="customFormatter" :language="zh" v-model="search.actionStartTime" style="display: inline-block;" />
                 ~ 活動結束日期：
                <datepicker ref="actionEndTime" :format="customFormatter" :language="zh" v-model="search.actionEndTime" style="display: inline-block;" />
                <br />
                <div align="center" style="margin-top: 5px;">
                  <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                  <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="left">
              <div class="s_dir">
                <input ref="file" type="file" @change="fileUpload()" style="display: none;" />
                <a v-if="checkedList.length > 0" href="#" @click.prevent="batchDelData" class="btn-upload btn btn-primary">刪除</a>
                <a href="#" @click.prevent="updateClass" class="btn-upload btn btn-primary">手動更新</a>
                <a v-if="isAdmin('stipendMage')" href="#" @click.prevent="importClass" class="btn-upload btn btn-primary">匯入課程資料</a>
              </div>
              <div style=" clear:both;">
                <a href="/bursary/files/持續管理-上傳範例.xlsx">課程資料(上傳範例)</a>
                <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="4%" >
                        <input type="checkbox" id="allCheck" name="allCheck" v-model="isAllCheck" @change="allSelection($event)" />
                      </th>
                      <th class="text-center" width="4%">來源</th>
                      <th class="text-center" width="4%">學年</th>
                      <th class="text-center" width="4%">學期</th>
                      <th class="text-center" width="9%">活動開始時間</th>
                      <th class="text-center" width="9%">活動結束時間</th>
                      <th class="text-center" width="6%">活動編號</th>
                      <th class="text-center" width="6%">活動類別</th>
                      <th class="text-center" width="19%">活動名稱</th>
                      <th class="text-center" width="10%">舉辦單位</th>
                      <th class="text-center" width="5%">舉辦人</th>
                      <th class="text-center" width="4%">時數</th>
                      <th class="text-center" width="8%">參加者學號</th>
                      <th class="text-center" width="8%">參加者名稱</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="刪除"  class="text-center">
                        <input  type="checkbox" :id="'checkId_'+index" name="checkId" :value="item" v-model="checkedList" @change="checkEvent(item)" />
                      </td>
                      <td data-title="資料來源" class="text-center">{{item.sourceType == 1 ? "系統" : "手動"}}</td>
                      <td data-title="學年" class="text-center">{{item.schYear}}</td>
                      <td data-title="學期" class="text-center">{{item.schTerm}}</td>
                      <td data-title="活動開始時間" class="text-center">{{item.actionStartTime}}</td>
                      <td data-title="活動結束時間" class="text-center">{{item.actionEndTime}}</td>
                      <td data-title="活動編號" class="text-center">{{item.actionSno}}</td>
                      <td data-title="活動類別" class="text-center">{{item.actionApplyType}}</td>
                      <td data-title="活動名稱" class="text-center">{{item.actionName}}</td>
                      <td data-title="活動舉辦單位" class="text-center">{{item.actionPosterUnit}}</td>
                      <td data-title="活動舉辦人" class="text-center">{{item.actionPoster}}</td>
                      <td data-title="活動時數" class="text-center">{{item.actionHour}}</td>
                      <td data-title="參加者學號" class="text-center">{{item.stuId}}</td>
                      <td data-title="參加者名稱數" class="text-center">{{item.stuName}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="panel-body text-center">
                <pageControl v-bind:page="search.page" v-bind:total="totalPage"></pageControl>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        page: 1,
        schYearTerm: null,
        actionStartTime: null,
        actionEndTime: null,
        stuId: null,
        stuName: null,
        actionName: null,
        sourceType: null
      },
      isAllCheck:false,
      checkedList: [],
      list: [],
      schYearTermList: [],
      totalPage: 0
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
    this.load();
    $(this.$refs.actionStartTime.$children[0].$el.children[0]).addClass("form-control").css("background-color", "#FFF");
    $(this.$refs.actionEndTime.$children[0].$el.children[0]).addClass("form-control").css("background-color", "#FFF");
  },
  methods: {
    load() {
      let actionStartTime = this.search.actionStartTime ? this.customFormatter(this.search.actionStartTime): null;
      let actionEndTime = this.search.actionEndTime ? this.customFormatter(this.search.actionEndTime): null;
      this.$http
        .get("/api/workstudyKeepManage", { params: {
          page: this.search.page,
          pageSize: 10,
          schYearTerm: this.search.schYearTerm,
          actionStartTime: actionStartTime,
          actionEndTime: actionEndTime,
          stuId: this.search.stuId,
          stuName: this.search.stuName,
          actionName: this.search.actionName,
          sourceType: this.search.sourceType,
        }})
        .then(a => {
          this.list = a.body.rows;
          this.totalPage = a.body.total;
          this.page = a.body.page;
          this.checkedList = [];
          this.isAllCheck = false;
        });
    },
    searchClear() {
      this.search.page = 1;
      this.search.actionStartTime = null;
      this.search.actionEndTime = null;
      this.search.stuId = null;
      this.search.stuName = null;
      this.search.actionName = null;
      this.search.sourceType = null;
      this.load();
    },
    searchSubmit() {
      this.updateGrid(1);
    },
    updateGrid(page){
			this.search.page = page;
			this.load();
		},
    updateClass() {
      this.$http
        .post("/api/workstudyKeepManage/updateClass")
        .then(a => {
          if (a.body.status) {
            alert("手動更新成功:" + a.body.msg);
            this.updateGrid(1);
          } else {
            alert("手動更新失敗:" + a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    importClass() {
      $(this.$refs.file).click();
    },
    fileUpload() {
      let file = this.$refs.file.files[0];
      if (!file) {
        alert("尚未選擇上傳檔案");
        return false;
      }
      if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        alert("請上傳EXCEL檔(xlsx)");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/api/workstudyKeepManage", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(a => {
          if (a.body.status) {
            bootbox.alert(a.body.msg);
            this.updateGrid(1);
          } else {
            bootbox.alert("上傳失敗:" + a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    delData(id) {
      if (!confirm("請問是否確認要刪除此筆資料？")) return false;
      this.$http.post("/api/workstudyKeepManage/delete/",JSON.stringify({ Id: id })).then(a => {
        if (a.body.status) {
          alert("刪除成功");
          this.load();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    allSelection(event) {
      this.checkedList = [];
      if(event.target.checked){
        this.checkedList = this.list
      }
    },
    checkEvent(item) {
      if(this.checkedList.length == this.list.length){
        this.isAllCheck = true;
      }else{
        this.isAllCheck = false;
      }
    },
    batchDelData() {
      if (!confirm("請問是否確認要刪除勾選的資料？")) return false;
      this.$http.post("/api/workstudyKeepManage/batchDelete",
        this.checkedList.map(c => c.id)
      ).then(a => {
        if (a.body.status) {
          alert("刪除成功");
          this.load();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
  }
};
</script>

<style scoped>
</style>
